define(
	'GoVirtualOffice.LoginRegHTMLMessage.LogLoginRegHTMLMessageinOriginRedirect',
	[
		'LoginRegHTMLMessage.View'
	],
	function (
		LoginRegHTMLMessageView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application) {

			var loginRegister;
			var environment;
			var config;

			loginRegister = application.getComponent('LoginRegisterPage');
			environment = application.getComponent('Environment');
			config = environment && environment.getConfig('digiConfigSettings.register') || {};

			if (loginRegister && config.loginRegHTMLMessage) {

				loginRegister.addChildView('Messages', function() {
					return new LoginRegHTMLMessageView({
						loginRegHTMLMessage: config.loginRegHTMLMessage
					});
				});
			}
		}
	};
});
